import {userManagementAxiosInstance} from "./axiosInstances";
import UserService from "./UserService";

export const userManagementService = {
    updateUserProfile: async (firstName?: string, lastName?: string): Promise<void> => {
        try {
            const userId = UserService.getUserId();
            const response = await userManagementAxiosInstance.put(
                `/profile/${userId}`,
                {
                    firstName: firstName,
                    lastName: lastName
                }
            );
            return response.data;
        }
        catch (error) {
            throw error;
        }
    },
    removeTotp: async (): Promise<void> => {
        try {
            const response = await userManagementAxiosInstance.delete(`/remove-totp`);
            return response.data;
        }
        catch (error) {
            throw error;
        }
    }
}
export default userManagementService;